var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGraphicIllustRover = function SvgGraphicIllustRover(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.44 226.56",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f9fa;}.cls-2{fill:#eadc98;}.cls-13,.cls-14,.cls-2,.cls-3,.cls-4,.cls-5,.cls-9{stroke:#7d858c;}.cls-10,.cls-11,.cls-13,.cls-14,.cls-15,.cls-2,.cls-3,.cls-4,.cls-5,.cls-8,.cls-9{stroke-miterlimit:10;stroke-width:3px;}.cls-3,.cls-7,.cls-8{fill:#fff;}.cls-4{fill:#cfdae2;}.cls-5{fill:#a5bac9;}.cls-6{fill:#7d858c;}.cls-8{stroke:#94c9b6;}.cls-9{fill:#a2d0c0;}.cls-10,.cls-11,.cls-13,.cls-14,.cls-15{fill:none;}.cls-10,.cls-11{stroke:#7f88c2;}.cls-10,.cls-11,.cls-13,.cls-15{stroke-linecap:round;}.cls-10{opacity:0.4;}.cls-11,.cls-16{opacity:0.15;}.cls-12{fill:#94c9b6;}.cls-15{stroke:#f1e8ba;}.cls-17{fill:#7f88c2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.71,172.67C-3.88,153.35-4.55,118.18,9.32,94.85,23.07,71.74,25.14,43,46.68,24.63,58.3,14.72,73.39,9.81,88.4,7c23.93-4.57,49.14-9.8,73.37-5.11,44.8,8.66,104.08,20.57,114.6,74.23,1.67,8.49,1,17.23.34,25.86l-5,64.77c-.13,1.61-.3,3.34-1.36,4.55a7.56,7.56,0,0,1-3.95,1.93c-10.5,2.77-21.84,5.5-32,1.6-5.8-2.24-11.06-6.6-17.28-6.57-2.95,0-5.78,1-8.63,1.82-10.58,2.89-21.77.63-32.71,1.51-65,5.23-70.24-9-104.62-2.39-5.32,1-10.69,2.37-16.1,1.92-4.73-.4-9.25-2.16-14-2.83a31.22,31.22,0,0,0-23.84,6.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.94,85.74H98.13c-3.21,0-5.81-2.87-5.81-6.42V67.88c0-3.54,2.6-6.42,5.81-6.42h46.81c3.21,0,5.81,2.88,5.81,6.42V79.32C150.75,82.87,148.15,85.74,144.94,85.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 102.16,
    y: 85.74,
    width: 40.98,
    height: 10.56,
    rx: 5.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.37,
    y: 96.23,
    width: 12.21,
    height: 55.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.76,136.85l15.65,19.67h96.25l15.83-20.82a4.77,4.77,0,0,0-3.84-7.66L99.46,129.11A4.77,4.77,0,0,0,95.76,136.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.78,156.52h97.49a0,0,0,0,1,0,0v23.91A5.27,5.27,0,0,1,203,185.7H116.06a5.27,5.27,0,0,1-5.27-5.27V156.52A0,0,0,0,1,110.78,156.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.07,73.27c0,3.82-2.45,7.63-7.38,7.63-4.68,0-7.75-4.12-7.29-8.61C100.36,63.08,114.06,63.91,114.07,73.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.31,72.26a.18.18,0,0,0-.36,0,6,6,0,0,1-8.07,4.38,5,5,0,0,0,8.43-4.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 104.55,
    cy: 70.58,
    rx: 2.35,
    ry: 2.05,
    transform: "translate(-12.97 116.42) rotate(-55.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.52,73.27c0,3.82-2.45,7.63-7.38,7.63-4.67,0-7.74-4.12-7.28-8.61C127.81,63.08,141.51,63.91,141.52,73.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M138.77,72.26a.18.18,0,0,0-.36,0,6,6,0,0,1-8.08,4.38,5,5,0,0,0,8.28-2.31A5.24,5.24,0,0,0,138.77,72.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 132,
    cy: 70.58,
    rx: 2.35,
    ry: 2.05,
    transform: "translate(-1.13 139) rotate(-55.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 91.7,
    y: 174.86,
    width: 43.47,
    height: 7.44,
    transform: "translate(-97.3 197.27) rotate(-62.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.98,
    y: 186.55,
    width: 43.47,
    height: 7.44,
    transform: "translate(-84.7 206.95) rotate(-52.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.27,
    y: 186.55,
    width: 43.47,
    height: 7.44,
    transform: "matrix(-0.62, -0.79, 0.79, -0.62, 176.34, 466.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.23,
    y: 161.19,
    width: 61.06,
    height: 6.76,
    transform: "translate(274.76 360.23) rotate(-167.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 96.46,
    cy: 207.98,
    r: 17.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.48,
    y: 151.37,
    width: 14.59,
    height: 14.59,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 156.34,
    cy: 207.98,
    r: 17.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.17,
    y: 164.9,
    width: 11.63,
    height: 11.63,
    rx: 5.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 213.83,
    cy: 207.98,
    r: 17.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 96.48,
    cy: 207.53,
    r: 5.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 156.71,
    cy: 207.53,
    r: 5.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 213.84,
    cy: 207.53,
    r: 5.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "207.17 66.48 204.42 66.48 202.75 128.26 208.84 128.26 207.17 66.48"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 205.79,
    cy: 64.46,
    r: 3.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199.61,70.72a9.34,9.34,0,1,1,13.07-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.62,76.08a14.85,14.85,0,1,1,15.81.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.93,120.51l-3.24-4.64L46.2,118.45l-5.3-6.51a1.47,1.47,0,0,1,.52-2.28h0a1.49,1.49,0,0,1,1.79.41l4.24,5.29L57.94,113l-2.7-4.65a1.36,1.36,0,0,1,.83-2h0a1.37,1.37,0,0,1,1.52.64l7.24,12.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.91,65.35l.31,1.78a21.9,21.9,0,0,0-9.16-11.76,22.36,22.36,0,1,0,6.8,30.71,22.46,22.46,0,0,0,3.47-12.59c2.9-1,6.15-2.55,8.32-3.6a1.05,1.05,0,0,0-.18-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M59.69,68.9a6.36,6.36,0,0,1-.87,3.3,6.12,6.12,0,0,1-2.33,2.27,6.58,6.58,0,0,1-3.2.8c-.22,0-.48,0-.78,0l-.32,1.37a1.38,1.38,0,0,1-2.71-.2l-.25-3.09a1.37,1.37,0,0,1,1.42-1.48h.18A3.77,3.77,0,0,0,53.39,71a2.81,2.81,0,0,0,1-2.22,2.91,2.91,0,0,0-.91-2.19,3.17,3.17,0,0,0-2.24-.86,3,3,0,0,0-2.18.75c-2,1.91-.92,3.18-4.32,2.71a1.38,1.38,0,0,1-1.34-1.68A6.2,6.2,0,0,1,45.5,64a9.19,9.19,0,0,1,6.07-1.86,10.11,10.11,0,0,1,4.23.84,6.79,6.79,0,0,1,2.87,2.36A6.34,6.34,0,0,1,59.69,68.9ZM47.94,84.32V81.45a1.37,1.37,0,0,1,1.37-1.37h2.84a1.37,1.37,0,0,1,1.37,1.37v2.87a1.37,1.37,0,0,1-1.37,1.37H49.31A1.37,1.37,0,0,1,47.94,84.32Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 144.77,
    y1: 56.27,
    x2: 143.1,
    y2: 50.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 156.18,
    y1: 61.29,
    x2: 161.36,
    y2: 58.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 151.29,
    y1: 57.47,
    x2: 153.99,
    y2: 52.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.26,170.58s-24.33-3.56-34.35,0c-21.61,7.81-36.94-4.13-45.21,0C14,179,.56,178.17.56,178.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M209.39,171.83s9.41-3.76,12.55-3.13,18.2,7.37,20.7,7.53c10,.62,27.5-7.27,58.48-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63,124.88l15,20.47a5.31,5.31,0,0,0,6.37,1.74l19.76-8.53a2,2,0,0,0,1.23-2.69h0a2.81,2.81,0,0,0-3.59-1.16l-19.17,8-17.7-24L60.11,121Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 261.7,
    y1: 57.86,
    x2: 261.7,
    y2: 64.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 258.14,
    y1: 61.41,
    x2: 265.17,
    y2: 61.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 172.28,
    y1: 15.19,
    x2: 172.28,
    y2: 22.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 168.72,
    y1: 18.75,
    x2: 175.74,
    y2: 18.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 181.53,
    y1: 91.32,
    x2: 181.53,
    y2: 96.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 178.67,
    y1: 94.18,
    x2: 184.32,
    y2: 94.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 98.55,
    y1: 34.45,
    x2: 98.55,
    y2: 40.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 95.48,
    y1: 37.52,
    x2: 101.55,
    y2: 37.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 11.69,
    y1: 127.35,
    x2: 11.69,
    y2: 133.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 8.62,
    y1: 130.42,
    x2: 14.68,
    y2: 130.42
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M239.64,97.07a2.16,2.16,0,1,1,2.16-2.15A2.16,2.16,0,0,1,239.64,97.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M239.64,92.89a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-.25a2.28,2.28,0,1,0,2.28,2.28,2.28,2.28,0,0,0-2.28-2.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M235,37.22a1.89,1.89,0,1,1-1.89,1.89A1.89,1.89,0,0,1,235,37.22m0-3a4.89,4.89,0,1,0,4.88,4.89A4.89,4.89,0,0,0,235,34.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120,18.26a2.16,2.16,0,1,1,2.15-2.15A2.16,2.16,0,0,1,120,18.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120,14.08a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-.25a2.28,2.28,0,1,0,2.28,2.28A2.28,2.28,0,0,0,120,13.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M33.71,146.11A1.88,1.88,0,1,1,31.83,148a1.89,1.89,0,0,1,1.88-1.88m0-3A4.88,4.88,0,1,0,38.6,148a4.89,4.89,0,0,0-4.89-4.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 161.08,
    cy: 108.47,
    r: 1.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M161.08,106.63a1.84,1.84,0,1,1-1.84,1.84,1.83,1.83,0,0,1,1.84-1.84m0-.25a2.09,2.09,0,1,0,2.08,2.09,2.1,2.1,0,0,0-2.08-2.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M65.88,27.44a2.09,2.09,0,1,1-2.1,2.09,2.1,2.1,0,0,1,2.1-2.09m0-3A5.09,5.09,0,1,0,71,29.53a5.1,5.1,0,0,0-5.09-5.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M187.59,30.21a2.16,2.16,0,1,1,2.15-2.16A2.16,2.16,0,0,1,187.59,30.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M187.59,26a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-.25a2.28,2.28,0,1,0,2.28,2.28,2.28,2.28,0,0,0-2.28-2.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M255,118.22a1.89,1.89,0,1,1-1.89,1.89,1.89,1.89,0,0,1,1.89-1.89m0-3a4.89,4.89,0,1,0,4.88,4.89,4.89,4.89,0,0,0-4.88-4.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M118,78.43a3.54,3.54,0,0,1,4.7-1.73"
  })))));
};
export { SvgGraphicIllustRover as ReactComponent };
export default __webpack_public_path__ + "static/media/GraphicIllust_Rover.4ff4d8d0.svg";